// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#version-display {
  position: absolute;
  left: 0;
  bottom: 0;
  font-size: 12px;
  padding: 5px 5px;
  border: 2px solid black;
  opacity: 0;
  z-index: 10;
  background-color: white;
}

#version-display:hover {
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/app/components/version-display/version-display.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,OAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,UAAA;EACA,WAAA;EACA,uBAAA;AACF;;AAEA;EACE,UAAA;AACF","sourcesContent":["#version-display {\r\n  position: absolute;\r\n  left: 0;\r\n  bottom: 0;\r\n  font-size: 12px;\r\n  padding: 5px 5px;\r\n  border: 2px solid black;\r\n  opacity: 0;\r\n  z-index: 10;\r\n  background-color: white;\r\n}\r\n\r\n#version-display:hover {\r\n  opacity: 1;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
